import { Route, Routes } from 'react-router-dom';
import PlayerResources from './views/PlayerResources';
import Home from './views/Home';

function App() {
  return (
    <Routes>
      <Route path="/:corp" element={<PlayerResources />} />
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
